import blue from '@material-ui/core/colors/blue';
import { createMuiTheme } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';

const Theme = createMuiTheme({
    typography: {
        useNextVariants: true,
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1380,
            xl: 1650,
        }
    },
    palette: {
        primary: {
            light: blue[300],
            main: "#0088CF",
            dark: blue[700],
        },
        error: {
            light: red[300],
            main: "#f44336",
            dark: red[700],
        },
        secondary: {
            light: green[300],
            main: '#5BA71B',
            dark: green[700],
        }
    },
    overrides: {
        MuiMenuItem: {
            root: {
                paddingLeft: '25px',
                paddingRight: '25px',
                paddingTop: "2px",
                paddingBottom: "2px",
                lineHeight: '20px',
                whiteSpace: 'normal',
                fontSize: '16px',
                '& svg': {
                    height: '20px',
                    marginRight: '20px',
                },
            },
        },
        MuiTableBody: {
            root: {
                fontSize: 14,
            },
        },
        MuiTableRow: {
            root: {
                height: 40,
            },
            head: {
                height: 53,
            }
        },
        MuiTableCell: {
            root: {
                padding: '0px 15px',
            },
            head: {
                fontSize: '12px',
                fontWeight: 'normal',
                lineHeight: '14px',
                textTransform: 'uppercase'
            },
        },
        MuiInput: {
            input: {
                color: '#555555',
                '&::-webkit-input-placeholder': {
                    color: 'rgba(0,0,0,0.38)',
                },
                width: '100%',
                '&$disabled': {
                    opacity: 0.5,
                },
            },

        },
        MuiButton: {
            root: {
                fontWeight: 400,
                minWidth: 0,
                minHeight: 32,
                margin: 5,
                height: '32px',
                lineHeight: .5,
                padding: '7px 15px',
                color: '#ffffff',
                backgroundColor: '#767676',
                '&$disabled': {
                    color: '#ffffff',
                    backgroundColor: '#aaaaaa',
                },
                '&:hover': {
                    textDecoration: 'none',
                    backgroundColor: '#666666',
                    '&$disabled': {
                        backgroundColor: '#aaaaaa',
                    },
                },
            },
            // flatPrimary: {
            //     color: '#ffffff',
            //     backgroundColor: '#0084c1',
            //     '&$disabled': {
            //         color: '#ffffff',
            //         backgroundColor: 'rgba(0,119,200,.3)',
            //     },
            //     '&:hover': {
            //         textDecoration: 'none',
            //         backgroundColor: '#006999',
            //         '&$disabled': {
            //             backgroundColor: '#61adca',
            //         },
            //     },
            // },
            contained: {
                minWidth: 0,
                margin: 5,
                height: 'auto',
                padding: '7px 15px',
                color: '#ffffff',
                backgroundColor: '#767676',
                '&$disabled': {
                    color: '#ffffff',
                    backgroundColor: '#aaaaaa',
                },
                '&:hover': {
                    textDecoration: 'none',
                    backgroundColor: '#666666',
                    '&$disabled': {
                        backgroundColor: '#aaaaaa',
                    },
                },
            },
        },
        MuiDialog: {
            paperWidthXs: {
                maxWidth: 500,
            },
            paperWidthMd: {
                maxWidth: 750,
            },
            paperWidthLg: {
                maxWidth: 1100,
            },
        },
        MuiDialogTitle: {
            root: {
                backgroundColor: '#0077c8',
                padding: '24px 30px 21px 27px',
            },
        },
        MuiRadio: {
            '&$checked': {
                color: '#0077C8'
            },
        },
        MuiDialogContent: {
            root: {
                overflowY: 'auto',
                padding: 0,
                '&:first-child': {
                    paddingTop: 0,
                },
            },
        },
        MuiDialogActions: {
            root: {
                margin: 0,
                padding: 14,
                backgroundColor: '#eeeeee',
            },
        },
        MuiSvgIcon: {
            root: {
                height: 20,
                width: 20,
            },
        },
        MuiSwitch: {
            '&$checked': {
                color: "#0077C8"
            },
            bar: {
                backgroundColor: 'rgba(0,0,0,0.3)'
            }
        },
        MuiSwitchLabel: {
            labelText: {
                fontSize: '13px'
            }
        },
        MuiChip: {
            root: {
                height:'24px'
            }
        }
    },
});

export default Theme

